import { SeasonListingItem } from "./SeasonListingItem";

const onlyOneHasBuzzId = (item1: SeasonListingItem, item2: SeasonListingItem) => {
    return !item1.buzzId !== !item2.buzzId;
};

const anyItemAlreadyMerged = (item1?: SeasonListingItem, item2?: SeasonListingItem) => {
    return item1?.merged || item2?.merged;
};

export const canSeasonsMerge = (item1?: SeasonListingItem, item2?: SeasonListingItem): boolean => {
    if (item1?.id === item2?.id) return false;

    if (anyItemAlreadyMerged(item1, item2)) return false;

    if (!item1 || !item2) return true;

    if (!onlyOneHasBuzzId(item1, item2)) return false;

    return true;
};
